import React from "react";
import { Link } from "react-router-dom";
import "./Sidebar.css";
import { FaBuilding, FaCouch, FaTachometerAlt, FaUsers } from "react-icons/fa"; 
import logo from "./Kubitos_golden_text.png";

const Sidebar = () => {
  const [userRole, setUserRole] = React.useState(localStorage.getItem("userRole"));

  React.useEffect(() => {
    const handleRoleChange = () => {
      setUserRole(localStorage.getItem("userRole"));
    };
    window.addEventListener("storage", handleRoleChange);
    return () => window.removeEventListener("storage", handleRoleChange);
  }, []);

  return (
    <div className="sidebar">
      {/* Logo and Name */}
      <div className="sidebar-header">
        <img src={logo} alt="Kubitos Logo" className="sidebar-logo" />
      </div>

      {/* Sidebar Menu */}
      <nav className="sidebar-menu">
        <ul>
          {/* Admin Only: Dashboard */}
          {userRole === "Admin" && (
            <Link to="/user/dashboard" className="sidebar-item">
              <FaTachometerAlt className="sidebar-icon" />
              Visualizações
            </Link>

          )}

          {/* Accessible to both Admin and Manager */}
          <Link to="/user/imoveis" className="sidebar-item">
            <FaBuilding className="sidebar-icon" />
            Lista Imóveis
          </Link>

          <Link to="/user/outros" className="sidebar-item">
            <FaCouch className="sidebar-icon" />
            Lista Outros
          </Link>
          {/* Admin Only: User Management */}
          {userRole === "Admin" && (
            <Link to="/user/usermanagement" className="sidebar-item">
              <FaUsers className="sidebar-icon" />
              Gestão de Utilizadores
            </Link>
          )}
        </ul>
      </nav>
    </div>
  );
};

export default Sidebar;
